import { Fragment } from "react";
import { GeoJSON, CircleMarker, Tooltip } from "react-leaflet";

export const MMI_SCALE = [
  [2, "#bfccff", "Weak"],
  [4, "#80ffff", "Light"],
  [5, "#7aff93", "Moderate"],
  [6, "#ffff00", "Strong"],
  [7, "#ffc800", "Very strong"],
  [8, "#ff9100", "Severe"],
  [9, "#ff0000", "Violent"],
];

const style = (f) => ({
  color: f.properties?.color || "#ffffff",
  weight: (f.properties?.value || 0) >= 6 ? 2.6 : 1.6,
  opacity: 0.95,
});

export const ShakeMapLayer = ({ events = [], onSelect }) =>
  events.map((e) => (
    <Fragment key={e.id}>
      <GeoJSON data={e.contours} style={style} interactive={false} />
      <CircleMarker
        center={[e.lat, e.lon]}
        radius={6}
        className={`atlas-shake atlas-shake-${e.id}`}
        pathOptions={{ color: "#ffffff", weight: 2, fillColor: "#ff2a2a", fillOpacity: 1 }}
        eventHandlers={{ click: () => onSelect && onSelect(e) }}
      >
        <Tooltip direction="top" offset={[0, -6]} className="atlas-tip" opacity={1}>
          <b>{e.title}</b>
          <br />
          Peak shaking MMI {e.max_mmi} · depth {Math.round(e.depth_km)} km
          <br />
          <span className="atlas-tip-muted">USGS ShakeMap · {new Date(e.time).toUTCString().slice(5, 22)} UTC</span>
        </Tooltip>
      </CircleMarker>
    </Fragment>
  ));
